//
import Model from "@/models/Model"

/**
* This class describes a authorize.
*
* @class      AAuthorize (name)
*/
export default class AInRevisionToArmed extends Model {

  /**
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'in_revision_to_in_armed'
  }
}